import { Box, Grid, useMediaQuery } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import {
  CmpButton,
  CmpDatePicker,
  CmpSelectBox,
  CmpTypographyField,
} from "../../Component/Common/ToolBox/ToolBox";
import { useSelector } from "react-redux";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import moment from "moment";
import { GetGitterColumns } from "../../Utility/Utilitys";
import { common_PutAwayBinMismatch_GETROW } from "../../Server/ApiV2";

const PutawayDiscrepancyReport = () => {
  const LocFocusOnLoad = useRef(null);
  const vMediaQuery = useMediaQuery("(max-width:450px)");
  const vRdxuserLoc = useSelector((state) => state.SliceGRNLocation.value);
  const [sGridrows, setGridrows] = useState([]);
  const [summaryObj, setSummaryObj] = useState({
    loc: vRdxuserLoc[0]?.UID,
    fromDate: new Date(),
    toDate: new Date(),
  });

  const fSummary_OnChange = (e) => {
    setSummaryObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fLoad = () => {
    GetSummaryList();
  };

  const GetSummaryList = async () => {
    let vSummaryListObj = {
      v_Loc: summaryObj.loc == "" ? vRdxuserLoc[0]?.UID : summaryObj.loc,
      v_Date1: moment(summaryObj.fromDate).format("MM/DD/YYYY"),
      v_Date2: moment(summaryObj.toDate).format("MM/DD/YYYY"),
    };
    const vSummaryList = await common_PutAwayBinMismatch_GETROW(
      vSummaryListObj
    );
    if (vSummaryList.status == 200) {
      let GridID =
        vSummaryList.data.ResultSet.length == 0
          ? []
          : vSummaryList.data.ResultSet?.map((obj, i) => ({
              ...obj,
              id: i + 1,
            }));
      setGridrows(GridID);
    } else {
      setGridrows([]);
    }
  };

  const [Gridcolumns, setGridcolumns] = useState([
    {
      field: "vocCode",
      headerName: "Voc.Code",
      hide: true,
      width: 150,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "vocName",
      headerName: "Voc.Name",
      hide: false,
      width: 300,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "vocNo",
      headerName: "Voc.No",
      hide: false,
      width: 150,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "postDt",
      headerName: "Post.Date",
      hide: false,
      width: 150,
      align: "right",
      headerAlign: "right",
    },
    {
      field: "party",
      headerName: "Party",
      hide: true,
      width: 150,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "partyName",
      headerName: "Party.Name",
      hide: true,
      width: 300,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "itmCd",
      headerName: "Item.Code",
      hide: false,
      width: 150,
      align: "right",
      headerAlign: "right",
    },
    {
      field: "itmName",
      headerName: "Item.Name",
      hide: false,
      width: 300,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "cardId",
      headerName: "Card.ID",
      hide: false,
      width: 250,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "qty",
      headerName: "Qty",
      hide: false,
      width: 100,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "unit",
      headerName: "Unit",
      hide: false,
      width: 100,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "baseQty",
      headerName: "Base.Qty",
      hide: false,
      width: 100,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "palletId",
      headerName: "Pallet.ID",
      hide: false,
      width: 150,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "binName",
      headerName: "Bin.Name",
      hide: false,
      width: 300,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "SuggestBin",
      headerName: "Suggest.Bin",
      hide: false,
      width: 300,
      align: "left",
      headerAlign: "left",
    },
  ]);

  useEffect(() => {
    GetGitterColumns(setGridcolumns, "PUT_AWAY_BIN_MISMATCH", Gridcolumns);
    fLoad();
    LocFocusOnLoad.current?.focus();
  }, []);

  return (
    <div className="container-fluid my-3">
      <div className="">
        <CmpTypographyField
          xcomponent={"h1"}
          xText={"PutAway Bin Mismatch Report"}
          xfontSize="20px"
          xtextDecoration="underline"
        />
      </div>
      <div className="Instant-picking-head">
        <Grid
          container
          spacing={{ xs: 2, sm: 2, md: 2 }}
          className="align-items-center mt-4"
        >
          <Grid item lg={2} md={3} xs={6}>
            <CmpSelectBox
              xLabelText="Location"
              xValue={
                summaryObj.loc === "" ? vRdxuserLoc[0]?.UID : summaryObj.loc
              }
              xOnChange={(event) => fSummary_OnChange(event)}
              xName={"loc"}
              xData={vRdxuserLoc}
              xValueMember={""}
              xDispalyMember={""}
              xError={false}
              xErrorMessage={false}
              xDisable={false}
            />
          </Grid>
          <Grid item lg={2} md={3} xs={6} className="bintransfer-data-date">
            <CmpDatePicker
              xLabelText={"From"}
              xValue={summaryObj.fromDate}
              xOnChange={(newValue) => {
                setSummaryObj((obj) => ({
                  ...obj,
                  fromDate: newValue.$d,
                }));
              }}
              xName={"fromDate"}
              xError={false}
              xErrorMessage={false}
            />
          </Grid>
          <Grid item lg={2} md={3} xs={6} className="bintransfer-data-date">
            <CmpDatePicker
              xLabelText={"To"}
              xValue={summaryObj?.toDate}
              xOnChange={(newValue) => {
                setSummaryObj((obj) => ({
                  ...obj,
                  toDate: newValue.$d,
                }));
              }}
              xName={"toDate"}
              xError={false}
              xErrorMessage={false}
            />
          </Grid>
          <Grid item lg={2} md={3} xs={6} className="bintransfet-data-load-btn">
            <CmpButton
              xbtnName="Load"
              xOnClick={fLoad}
              xVariant="contained"
              xSize="small"
            />
          </Grid>
        </Grid>

        <Box
          sx={{ height: vMediaQuery ? "60vh" : "70vh", width: "100%" }}
          className="bin-transfer-data"
        >
          <DataGrid
            rowHeight={30}
            headerHeight={40}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0
                ? "mui-even-row"
                : "mui-odd-row"
            }
            sx={{
              border: 1,
              borderColor: "primary.light",
            }}
            rows={sGridrows}
            columns={Gridcolumns}
            // pageSize={5}
            // rowsPerPageOptions={[5]}
            hideFooter={sGridrows.length < 100}
            components={{
              Toolbar: vMediaQuery ? "" : GridToolbar,
            }}
            // onRowClick={fOnRowClick}
          />
        </Box>
      </div>
    </div>
  );
};

export default PutawayDiscrepancyReport;
